import type { ServerToClientEvent } from '../types';

const events: ServerToClientEvent[] = [];

export const registerEvent = (event: ServerToClientEvent) => {
	events.push(event);
};

/**
 * Take all events registered so far, return them, and clear the list.
 */
export const drainEvents = (): ServerToClientEvent[] => {
	return events.splice(0, events.length);
};
